/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const GreaterThanVersion: core.serialization.ObjectSchema<
    serializers.GreaterThanVersion.Raw,
    Truvity.GreaterThanVersion
> = core.serialization.object({
    value: core.serialization.number(),
});

export declare namespace GreaterThanVersion {
    export interface Raw {
        value: number;
    }
}
